let config = require('./config')
let utils = require('@common/utils')
let request = require('@common/request')
let iBorad = require('@common/iBorad')
require('@common/old.api')
let mask = require('../../modules/mask/index')
let lotteryChanceNum = $('#lotteryBtn span')
let hasMoney;

_qblog.setting({key: 1111, tcss: true});
_qblog.wsd.click("GREATEXPECTATIONS.PV")

//AMS新集成
zHttp.baseUrl = "http://iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;
// 是否在进行抽奖动画,防止用户频繁点击抽奖
var inGame = false;
//是否提示分享增加抽奖机会
var showNotShare = false;
//main
let Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID: 272570,
  loadExtHandler: true,
  init: function () {
    Page.superclass.init.apply(this, arguments);
    if (!(navigator.userAgent.match(/Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i)) && !qbsdk.isQB()) {
      mask("QBrowser", '本活动为QQ浏览器专属活动', '请使用QQ浏览器参加')
    }
  },
  initEvent: function () {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    qq.login.bind('login', function () {});
    qq.login.bind('logout', function () {
      $('.btn_lucky').html('<span>登录获取抽奖次数</span>');
      $('.page_0 .dy').removeClass('yi').html('<a href="javascript:void(0)" onclick="lottery.sub(true)">');
      sessionStorage.removeItem("userInfo")
    });
    if (qq.login.getUin()) {
      $('.btn_lucky').html('<span >还有<i id="money">0</i>次机会</span>');
      lottery.queryTicket();
      lottery.getVideoInfo();
    }
    lottery.queryLotteryNamelist();
    var light = $('#luckyLight');
    var _flag = true;
    setInterval(function () {
      if (_flag) {
        _flag = false;
        light.addClass('active');
      } else {
        _flag = true;
        light.removeClass('active');
      }
    }, 1000);
    // lottery.getVideosInfo();
  },

})
window.page = new Page()



// WEBPACK FOOTER //
// ./pages/index/index.js